// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { IstatTypeFragment } from './istat-type.fragment.generated';
export type OwnerIstatFragment = { __typename?: 'OwnerIstatDTO', description: string, id: number, istatBeds: string | null, istatCode: string | null, istatRooms: string | null, istatToilets: string | null, istatUrl: string | null, istatUser: string | null, ownerId: number, paidCasualWorkers: number | null, paidRegularWorkers: number | null, psIstatGroup: number | null, sendFacilityClosure: boolean, sendIstatClosure: boolean, sendOnline: boolean, unpaidWorkers: number | null, istatType: { __typename?: 'IstatTypeDTO', beds: boolean, countryCode: string, daily: boolean, fromTo: boolean, id: number, istatCode: boolean, istatPassword: boolean, istatUrl: boolean, istatUser: boolean, monthly: boolean, needSearch: boolean, openingDays: boolean, paidCasualWorkers: boolean, paidRegularWorkers: boolean, printable: boolean, rooms: boolean, sendFacilityClosure: boolean, sendFile: boolean, sendIstatClosure: boolean, sendOnline: boolean, toilets: boolean, type: Types.IstatTypeEnum, unpaidWorkers: boolean, cityTax: boolean } };

export const OwnerIstatFragment = gql`
    fragment OwnerIstat on OwnerIstatDTO {
  description
  id
  istatBeds
  istatCode
  istatRooms
  istatToilets
  istatUrl
  istatUser
  ownerId
  paidCasualWorkers
  paidRegularWorkers
  psIstatGroup
  sendFacilityClosure
  sendIstatClosure
  sendOnline
  unpaidWorkers
  istatType {
    ...IstatType
  }
}
    ${IstatTypeFragment}`;
/* eslint-enable */